import styled from 'styled-components';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import { ExtraSmall } from '../Responsive';
import { useState } from 'react';
import { SecondSliderItems } from "../Assets/data.js";



// Styled Components
const Container=styled.div`
// background-color: orange;
display:flex;
height: 40vh;
margin: 50px auto;
position: relative;
overflow: hidden;
width: 88vw;
`
const Wrapper=styled.div`
display:flex;
height: 100%;
gap: 20px;
transform: translateX(${props=>props.slideIndex*-100}vw);
transition: all 1.5s ease;
`
const Slide=styled.div`
 background-color: pink;
 height: 100%;
 width: 25vw;
 ${ExtraSmall({width:'100vw'})}
`
const Arrow=styled.div`
background-color: transparent;
display:flex;
cursor:pointer;
align-items:center;
justify-content:center;
height: 60px;
position: absolute;
left: ${props=>props.direction==='left'&&'10px'};
right: ${props=>props.direction==='right'&&'10px'};
bottom: 10px;
width: 60px;
z-index:999;
`
const Image=styled.img`
height: 100%;
object-fit:cover;
width: 100%;
`
function Workslide() {
    const[slideIndex,setSlideIndex]=useState(0)
    const slidesLength = SecondSliderItems.length;
  
    const handleClick=(direction)=>{

        if(direction==='left'){                      
            setSlideIndex(slideIndex>0?slideIndex-1:slidesLength-1)
        }else{
            setSlideIndex(slideIndex<slidesLength-1?slideIndex+1:0)
        }
    
    }
  return (
   <Container>

    <Arrow direction="left" onClick={()=>handleClick("left")}>
      <WestIcon style={{fontSize:"30px",color:"gray"}}/>
    </Arrow>

      <Wrapper slideIndex={slideIndex}>
        {
            SecondSliderItems.map((item)=>{
                return(
                    <Slide><Image src={item.img} alt="imgs"></Image></Slide>
                )
            })
        }       
      </Wrapper> 

      <Arrow direction="right" onClick={()=>handleClick('right')}>
        <EastIcon style={{fontSize:"30px",color:"gray"}}/>
      </Arrow>
      
   </Container>
  );
}

export default Workslide;